var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScanBarcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83594 8.25016V5.9585C1.83594 3.676 3.67844 1.8335 5.96094 1.8335H8.2526",
    stroke: "#F9FAFB",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 1.8335H16.0417C18.3242 1.8335 20.1667 3.676 20.1667 5.9585V8.25016",
    stroke: "#F9FAFB",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1641 14.6665V16.0415C20.1641 18.324 18.3216 20.1665 16.0391 20.1665H14.6641",
    stroke: "#F9FAFB",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2526 20.1667H5.96094C3.67844 20.1667 1.83594 18.3242 1.83594 16.0417V13.75",
    stroke: "#F9FAFB",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6224 6.4165V8.24984C9.6224 9.1665 9.16406 9.62484 8.2474 9.62484H6.41406C5.4974 9.62484 5.03906 9.1665 5.03906 8.24984V6.4165C5.03906 5.49984 5.4974 5.0415 6.41406 5.0415H8.2474C9.16406 5.0415 9.6224 5.49984 9.6224 6.4165Z",
    stroke: "#F9FAFB",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9583 6.4165V8.24984C16.9583 9.1665 16.5 9.62484 15.5833 9.62484H13.75C12.8333 9.62484 12.375 9.1665 12.375 8.24984V6.4165C12.375 5.49984 12.8333 5.0415 13.75 5.0415H15.5833C16.5 5.0415 16.9583 5.49984 16.9583 6.4165Z",
    stroke: "#F9FAFB",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6224 13.75V15.5833C9.6224 16.5 9.16406 16.9583 8.2474 16.9583H6.41406C5.4974 16.9583 5.03906 16.5 5.03906 15.5833V13.75C5.03906 12.8333 5.4974 12.375 6.41406 12.375H8.2474C9.16406 12.375 9.6224 12.8333 9.6224 13.75Z",
    stroke: "#F9FAFB",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9583 13.75V15.5833C16.9583 16.5 16.5 16.9583 15.5833 16.9583H13.75C12.8333 16.9583 12.375 16.5 12.375 15.5833V13.75C12.375 12.8333 12.8333 12.375 13.75 12.375H15.5833C16.5 12.375 16.9583 12.8333 16.9583 13.75Z",
    stroke: "#F9FAFB",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanBarcode);
export default __webpack_public_path__ + "static/media/scan-barcode.407b701e8cdd460a9f40b446f6d4c78c.svg";
export { ForwardRef as ReactComponent };